import React, {useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import Button from "../../components/button";
import {FaEraser} from "react-icons/fa";
import SelectComponent from "../../components/select-component";
import InputForm from "../../components/input-form";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import {useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import orderService from "../../services/order-service";
import general from "../../utils/general";

const initialFilters = {
    status: {value: "with_pending", label: "Com pendências"},
    searchData: "",
}

const Order = () => {
    const [filters, setFilters] = useState(initialFilters);

    const navigate = useNavigate();

    useEffect(() => {
        document.title = "SISTEMA INTERNO";
    }, []);

    const {data} = useQuery({
        queryFn: () => orderService.list(filters).then(({data}) => data),
        queryKey: ["orders", {filters}]
    });

    const [columnDefs] = useState([
        { field: "id", headerName: "ID", width: 70 },
        { field: "date_initial", headerName: "Abertura",
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        { field: "date_final", headerName: "Encerramento",
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        { field: "status", headerName: "Status"},
        { field: "project_name", headerName: "Projeto", flex: 1, minWidth: 250 },
        { field: "product_place", headerName: "Produto (Localização)", flex: 1, minWidth: 250 },
        { field: "hardware_attendance_id", headerName: "Chamado", width: 90, cellStyle: {color: "#1266f1"} }
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: true}), []);

    const onCellClicked = (cell) => {
        const {id, hardware_attendance_id} = cell.data;

        if (cell.column.colId === "hardware_attendance_id") {
            navigate(`/hardware-attendances/form/${hardware_attendance_id}`);
            return;
        }

        navigate(`/orders/form/${id}/${hardware_attendance_id}`);
    };

    const handleInput = ({target: {id, value}}) => setFilters(prev => ({...prev, [id]: value}));

    const handleSelect = (id, value) => setFilters(prev => ({...prev, [id]: value}));

    return (
        <TemplateDefault title={"Ordens de serviço"}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-12">
                    <div className="col-span-3 text-gray-900">
                        <SelectComponent
                            instanceId="status"
                            label="Status"
                            options={[
                                {value: "with_pending", label: "Com pendências"},
                                {value: "without_pending", label: "Sem pendências"},
                            ]}
                            value={filters.status}
                            onChange={(value) => handleSelect("status", value)}
                            name="status"
                            isClearable={false}
                        />
                    </div>

                    <div className="col-span-9">
                        <div className="flex justify-between">
                            <InputForm id="searchData" label="Pesquisar" col="w-[calc(100%-60px)]" type="search"
                                       value={filters.searchData}
                                       onChange={handleInput}/>
                            <div>
                                <Button onClick={() => setFilters(initialFilters)}>
                                    <FaEraser/>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"ag-theme-quartz grid mt-4"} style={{height: "calc(100vh - 185px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={data ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[20, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default Order;